module.exports = __webpack_public_path__ + "img/twoRed.4d17d0ab.jpg";